import { render, staticRenderFns } from "./floating-footer.vue?vue&type=template&id=12a3fc8f&scoped=true&"
import script from "./floating-footer.vue?vue&type=script&lang=ts&"
export * from "./floating-footer.vue?vue&type=script&lang=ts&"
import style0 from "./floating-footer.vue?vue&type=style&index=0&id=12a3fc8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3fc8f",
  null
  
)

export default component.exports